/* eslint-disable */
// /src/services/membersService.js
// Firestore 기반 members 테이블 서비스
// - 컬렉션: "members"
// - 역할: 가입/로그인/자동로그인용 기본 멤버데이터 관리
// - 이 레벨에서는 등급/가맹/개인·법인 계산은 하지 않음 (approvals/settlements에서 별도 처리)

import { db } from "./firebase";
import {
    collection,
    getDocs,
    query,
    where,
    limit,
    addDoc,
    serverTimestamp,
} from "firebase/firestore";

const membersCol = collection(db, "members");

// 내부 헬퍼: 스냅샷에서 첫 문서만 꺼내기
function pickFirst(snap) {
    let first = null;
    snap.forEach((doc) => {
        if (!first) {
            first = { id: doc.id, ...doc.data() };
        }
    });
    return first;
}

/**
 * 전화번호 기준 가입 여부 확인
 * - SignupPage에서 "이미 가입된 번호인지" 체크할 때 사용
 */
export async function isPhoneRegisteredInMembers(phoneE164) {
    if (!phoneE164) return false;
    const q1 = query(
        membersCol,
        where("phoneE164", "==", phoneE164),
        limit(1)
    );
    const snap = await getDocs(q1);
    return !snap.empty;
}

/**
 * 아이디(username) 중복 체크
 */
export async function isUsernameTaken(username) {
    if (!username) return false;
    const q1 = query(membersCol, where("username", "==", username), limit(1));
    const snap = await getDocs(q1);
    return !snap.empty;
}

/**
 * username + password 조합으로 멤버 찾기 (로그인용)
 * - 지금 단계에선 password 평문 비교 (운영 땐 해시 권장)
 */
export async function findMemberByUsernamePassword(username, password) {
    if (!username || !password) return null;
    const q1 = query(
        membersCol,
        where("username", "==", username),
        where("password", "==", password),
        limit(1)
    );
    const snap = await getDocs(q1);
    return pickFirst(snap);
}

/**
 * phoneE164 기준으로 멤버 찾기 (자동 로그인/복구용)
 */
export async function findMemberByPhone(phoneE164) {
    if (!phoneE164) return null;
    const q1 = query(
        membersCol,
        where("phoneE164", "==", phoneE164),
        limit(1)
    );
    const snap = await getDocs(q1);
    return pickFirst(snap);
}

/**
 * 새 멤버 생성 (가입)
 * - username / password / name / phoneE164 / carNumber 필수
 * - 등급/가맹/개인·법인 정보는 여기서 다루지 않음
 */
export async function createMember({
    username,
    password,
    name,
    phoneE164,
    carNumber,
    memberType, // "personal" | "corporate" | "general"
}) {
    if (!username || !password || !name || !phoneE164 || !carNumber) {
        throw new Error("필수 항목이 누락되었습니다.");
    }
    if (!memberType) {
        throw new Error("회원 유형이 선택되지 않았습니다.");
    }

    const now = serverTimestamp();

    const payload = {
        username,
        password, // 주의: 현재는 평문. 운영 전환 시 해시로 변경 권장.
        name,
        phoneE164,
        carNumber,
        memberType, // 🔹 회원 유형 저장
        createdAt: now,
        updatedAt: now,
    };

    const docRef = await addDoc(membersCol, payload);

    // addDoc 직후에는 필드만 재구성해서 반환
    return {
        id: docRef.id,
        ...payload,
    };
}
